import IconInstagram from "src/icons/IconInstagram";
import ShareItem from "../../components/ShareItem";
import { ShareInstagramStoryDataType } from "./shareInstagramStoryHelpers";
import useShareInstagramStory from "./useShareInstagramStory";

const ShareInstagramStory = ({ data }: { data: ShareInstagramStoryDataType }) => {
	const { handlePress, loading } = useShareInstagramStory();

	return (
		<ShareItem
			loading={loading}
			Icon={IconInstagram}
			name="Stories"
			onPress={() => handlePress(data)}
		/>
	);
};
export default ShareInstagramStory;
